// ============================================================================
// HEBREW BIBLE PASSAGES - תנ"ך
// ============================================================================
// טקסטים מהתנ"ך בעברית עם מספרי סטרונג

export const biblePassagesHe = {
  "Bereshit_1": {
    book: "בראשית",
    chapter: 1,
    title: "בריאת העולם",
    verses: [
      { number: 1, text: "בְּרֵאשִׁית בָּרָא אֱלֹהִים אֵת הַשָּׁמַיִם וְאֵת הָאָרֶץ", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "וְהָאָרֶץ הָיְתָה תֹהוּ וָבֹהוּ וְחֹשֶׁךְ עַל פְּנֵי תְהוֹם וְרוּחַ אֱלֹהִים מְרַחֶפֶת עַל פְּנֵי הַמָּיִם", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "וַיֹּאמֶר אֱלֹהִים יְהִי אוֹר וַיְהִי אוֹר", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "וַיַּרְא אֱלֹהִים אֶת הָאוֹר כִּי טוֹב וַיַּבְדֵּל אֱלֹהִים בֵּין הָאוֹר וּבֵין הַחֹשֶׁךְ", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "וַיִּקְרָא אֱלֹהִים לָאוֹר יוֹם וְלַחֹשֶׁךְ קָרָא לָיְלָה וַיְהִי עֶרֶב וַיְהִי בֹקֶר יוֹם אֶחָד", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "וַיֹּאמֶר אֱלֹהִים יְהִי רָקִיעַ בְּתוֹךְ הַמָּיִם וִיהִי מַבְדִּיל בֵּין מַיִם לָמָיִם", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "וַיַּעַשׂ אֱלֹהִים אֶת הָרָקִיעַ וַיַּבְדֵּל בֵּין הַמַּיִם אֲשֶׁר מִתַּחַת לָרָקִיעַ וּבֵין הַמַּיִם אֲשֶׁר מֵעַל לָרָקִיעַ וַיְהִי כֵן", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "וַיִּקְרָא אֱלֹהִים לָרָקִיעַ שָׁמָיִם וַיְהִי עֶרֶב וַיְהִי בֹקֶר יוֹם שֵׁנִי", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "וַיִּבְרָא אֱלֹהִים אֶת הָאָדָם בְּצַלְמוֹ בְּצֶלֶם אֱלֹהִים בָּרָא אֹתוֹ זָכָר וּנְקֵבָה בָּרָא אֹתָם", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "וַיַּרְא אֱלֹהִים אֶת כָּל אֲשֶׁר עָשָׂה וְהִנֵּה טוֹב מְאֹד וַיְהִי עֶרֶב וַיְהִי בֹקֶר יוֹם הַשִּׁשִּׁי", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Tehilim_23": {
    book: "תהלים",
    chapter: 23,
    title: "ה' רועי",
    verses: [
      { number: 1, text: "יְהוָה רֹעִי לֹא אֶחְסָר", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "בִּנְאוֹת דֶּשֶׁא יַרְבִּיצֵנִי עַל מֵי מְנֻחוֹת יְנַהֲלֵנִי", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "נַפְשִׁי יְשׁוֹבֵב יַנְחֵנִי בְמַעְגְּלֵי צֶדֶק לְמַעַן שְׁמוֹ", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "גַּם כִּי אֵלֵךְ בְּגֵיא צַלְמָוֶת לֹא אִירָא רָע כִּי אַתָּה עִמָּדִי שִׁבְטְךָ וּמִשְׁעַנְתֶּךָ הֵמָּה יְנַחֲמֻנִי", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "תַּעֲרֹךְ לְפָנַי שֻׁלְחָן נֶגֶד צֹרְרָי דִּשַּׁנְתָּ בַשֶּׁמֶן רֹאשִׁי כּוֹסִי רְוָיָה", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "אַךְ טוֹב וָחֶסֶד יִרְדְּפוּנִי כָּל יְמֵי חַיָּי וְשַׁבְתִּי בְּבֵית יְהוָה לְאֹרֶךְ יָמִים", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Yochanan_3": {
    book: "יוחנן",
    chapter: 3,
    title: "ישוע ונקדימון",
    verses: [
      { number: 16, text: "כִּי כָּכָה אָהַב אֱלֹהִים אֶת הָעוֹלָם עַד כִּי נָתַן אֶת בְּנוֹ הַיָּחִיד לְמַעַן כָּל הַמַּאֲמִין בּוֹ לֹא יֹאבַד כִּי אִם יִהְיֶה לּוֹ חַיֵּי עוֹלָם", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "כִּי לֹא שָׁלַח אֱלֹהִים אֶת בְּנוֹ לָעוֹלָם לִשְׁפֹּט אֶת הָעוֹלָם כִּי אִם לְמַעַן יִוָּשַׁע הָעוֹלָם עַל יָדוֹ", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "הַמַּאֲמִין בּוֹ לֹא נִשְׁפָּט וְהַלֹּא מַאֲמִין כְּבָר נִשְׁפָּט עַל אֲשֶׁר לֹא הֶאֱמִין בְּשֵׁם בֶּן אֱלֹהִים הַיָּחִיד", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Filipim_4": {
    book: "פיליפים",
    chapter: 4,
    title: "שלום אלוהים",
    verses: [
      { number: 4, text: "שִׂמְחוּ בָאָדוֹן תָּמִיד שׁוּב אֹמַר שִׂמְחוּ", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "אַל תִּדְאֲגוּ דָבָר כִּי אִם בְּכָל תְּפִלָּה וּבַקָּשָׁה בְּתוֹדָה תִּוָּדְעוּ בַקְשׁוֹתֵיכֶם לֵאלֹהִים", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "וּשְׁלוֹם אֱלֹהִים הָעוֹלֶה עַל כָּל שֵׂכֶל יִשְׁמֹר אֶת לְבַבְכֶם וְאֶת מַחְשְׁבוֹתֵיכֶם בַּמָּשִׁיחַ יֵשׁוּעַ", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "הַכֹּל אוּכַל בַּמָּשִׁיחַ הַמְחַזְּקֵנִי", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesHe;
